import React, { useState, useEffect } from 'react';
import {Helmet} from "react-helmet";
import Loader from "react-loader-spinner";
import { Link } from 'react-router-dom';
import Parser from 'html-react-parser';
import Swal from 'sweetalert2'
import all_function from '../../../config/All_function';
import Pagination from "../../common/pagination/Pagination";
import Meta from '../../common/Meta';
import API from '../../../config/Api';
import './Block.css';

let  Block = (props)=> {     
    
	const queryParams  = new URLSearchParams(window.location.search) 

    let __page_number = 1;
	if(queryParams.get('page_number')){		
		__page_number = parseInt(queryParams.get('page_number')) 
	}
	let __title = "";
	if(queryParams.get('title')){		
		__title = queryParams.get('title') 
	}
	let __identity = "";
	if(queryParams.get('identity')){	
		__identity = queryParams.get('identity') 
	}	
	let __status = "";
	if(queryParams.get('status')){	
		__status = queryParams.get('status') 
	}      

	const item_per_page = 2	
	const metaData = {
		meta_title			: 'Page',
		meta_description	: '',
		meta_keywords		: '',
	}		
	
	const [page_number,set_page_number]   	= useState(__page_number)
	const [title,set_title] 				= useState(__title)
	const [identity,set_identity] 			= useState(__identity)
	const [status,set_status] 				= useState(__status)
	const [total,set_total] 				= useState(0)
	const [records,set_records] 			= useState(null)	
	let [sl_no,set_sl_no] 			    	= useState(0)	
     
	const fetchData = async (page_number)=> {	
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');	
		headers.append('x-access-token', localStorage.getItem('adminToken'));	
		
		let params = {
			'title':title,
			'identity':identity,
			'status':status,
			'item_per_page':item_per_page,
			'page_number':page_number
		}
		let querystring = all_function.objToQuerystring(params)
		const response  = await fetch(API.BLOCK+'?'+querystring,{		
			method: 'GET',  
			headers: headers			
		})
		const result = await response.json();	
		if(result){				
			set_total(result.option.total)
			set_records(result.data)
			set_sl_no(result.option.sl_no)
			set_page_number(page_number)		
		}					   
	}    
	const handleCheckall = (e)=>{
		let inputs = document.querySelectorAll('.selected-chk');  	
		if(e.target.checked){			
			for (var i = 0; i < inputs.length; i++) {   
				inputs[i].checked = true;   
			}   
		} 
		else{
			for (var j = 0; j < inputs.length; j++) {   
				inputs[j].checked = false;   
			}   
		}	
	}  
  
	const setBrowserUrl = (pgNo)=>{	
		const location = new URL(window.location);
		location.search="";
		if(title){
			location.searchParams.set('title', title);
		}
		if(identity){
			location.searchParams.set('identity',identity);
		}	
		if(status){
			location.searchParams.set('status', status);
		}	
		if(pgNo){
			location.searchParams.set('page_number', pgNo);
		}
		window.history.pushState({},'', location);
	}
	const handleSubmit = (e)=>{
		e.preventDefault();	
		setBrowserUrl(0)	
		fetchData(1)	
	}
	
	const handlePaginate = (pgNo)=>{
		setBrowserUrl(pgNo)		
		fetchData(pgNo); 		
	}
	const confirmDelete = async (blockID)=>{	
		Swal.fire({
			icon: 'warning',
			title: 'Are you sure?',
			text: "You want to delete this item!",			
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, delete it!'
			}).then( async (result) => {
			if (result.isConfirmed) {				
				let headers = new Headers();
				headers.append('Content-Type', 'application/json');		    
				headers.append('x-access-token', localStorage.getItem('adminToken'));		
				await fetch(API.BLOCK+'/'+blockID,{		
					method: 'DELETE', 
					headers: headers
				});			
				setBrowserUrl(0)	          
				fetchData(1)
				Swal.fire({
					icon: 'success',
					title: 'Deleted!',
					text: "Selected item has been deleted."
				})		
			}
		})	
  	} 
	const applyToSelected = (action)=>{
		let selected_ID = [];
		let inputs      = document.querySelectorAll('.selected-chk:checked');  	
		selected_ID     = Array.from(inputs).map(x => x.value)
	
		if(action && inputs.length){
			Swal.fire({
				icon: 'warning',
				title: 'Are you sure?',
				text: "You want to perform selected action",			
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, do it!'
			}).then( async (result) => {
				if (result.isConfirmed) {
					
					let headers = new Headers();
					headers.append('Content-Type', 'application/json');		    
					headers.append('x-access-token', localStorage.getItem('adminToken'));
					
					if(action==='Enable' || action==='Disable'){
						await fetch(API.BLOCK,{		
							method: 'PUT', 
							headers: headers,			
							body: JSON.stringify({
								'blockID':selected_ID,	
								'action':action				
							})	
						});					
						setBrowserUrl(0)				
						fetchData(1)					
						Swal.fire({
							icon: 'success',
							title: 'Updated!',
							text: 'Selected item has been updated successfully.'
						})	
					}
					else if(action==='Delete'){
						await fetch(API.BLOCK,{		
							method: 'DELETE', 
							headers: headers,			
							body: JSON.stringify({
								'blockID':selected_ID									
							})	
						});					
						setBrowserUrl(0)					
						fetchData(1)					
						Swal.fire({
							icon: 'success',
							title: 'Updated!',
							text: 'Selected item has been Deleted successfully.'
						})	
					}
				}
			})
		}	
  	}     
	useEffect( ()=>{			
		if(page_number){	
			fetchData(page_number);
		}
	},[page_number])	

	let pageCount   = Math.ceil(total/item_per_page);  

    return (
	<>	
		<Meta metaData={metaData} />		
		<Helmet defer={false}>	
		<script>
		
		</script>
		</Helmet>	    
				
		<div className="pagetitle">
			<h1>Block</h1>
			<nav>
			<ol className="breadcrumb">
				<li className="breadcrumb-item"><Link to="/">Home</Link></li>				
				<li className="breadcrumb-item active">Block</li>
			</ol>
			</nav>
		</div>
		
		<section className="section">
		<div className="row">
			<div className="col-lg-12">
				<div className="card">
				
				<div className="card-header">
				<div className='pull-right'> 
				<Link to="add-block" className="p-1"><button type="button" className="btn btn-primary">+ Add New</button></Link>
				</div>
				</div>
				
				<form id="frmFilter" name="frmFilter" method="post" encType="multipart/form-data" onSubmit={handleSubmit}>				
				<div className="card-body table-responsive">					         
				<table className="table table-hover">
					<thead>
					<tr>
					    <th><input className="form-check-input checkall" type="checkbox" onClick={handleCheckall} /></th>
						<th scope="col" width="5%">SL</th>
						<th scope="col">Title</th>
						<th scope="col">Identity</th>
						<th scope="col">Status</th>
						<th scope="col" width="10%" className="text-center">Action</th>						
					</tr>
					<tr>
						<td>&nbsp;</td>
						<td>&nbsp;</td>
						<td>
						<input className="form-control" type="text" 
						name="title" 
						value={title}  
						onChange={ (e)=> set_title(e.target.value) } />	
						</td>
						<td>
						<input className="form-control" type="text" 
						name="identity" 
						value={identity}  
						onChange={ (e)=> set_identity(e.target.value) } />
						</td>

						<td>
						<select className="form-select" name="status" value={status} onChange={ (e)=> set_status(e.target.value) }>
							<option value=""></option>
							<option value="0">Inactive</option>
							<option value="1">Active</option>
						</select>
						</td>

						<td className="text-center">
						<button type="submit" name="OkFilter" id="OkFilter" className="btn  btn-primary">Filter</button>
						</td>
					</tr>
					</thead>
					<tbody>
					{records &&
						records.map((doc,index) => ( 
						<tr key={index+1}>
							<td>							
							{doc.deletable===1 &&
								<input type="checkbox" className="form-check-input selected-chk" name="id[]" value={doc.blockID} />
							}
							</td>
							<td>{++sl_no}</td>
							<td>{Parser(doc.title)}</td>
							<td>{doc.identity}</td>
							<td>
								{doc.status===0 &&
									<span className="badge rounded-pill bg-danger">InActive</span>
								}
								{doc.status===1 &&
									<span className="badge rounded-pill bg-success">Active</span>
								}
							</td>
							<td className="text-center">
							    
								<Link to={`edit-block/${doc.blockID}`}>
								<button type="button" className="btn btn-info btn-sm" title='Edit'>
								<i className="bi bi-pencil-square"></i>
								</button>
								</Link>
								{doc.deletable===1 &&
									<button type="button" className="btn btn-danger btn-sm" title='Delete' onClick={()=>confirmDelete(doc.blockID)}>
									<i className="bi bi-trash"></i>
									</button>
								}
							</td>
						</tr> 						
                       ))}  									           
					</tbody>
				</table>
				{records && records.length>=1 &&		
				<div className="row">
					<div className="col-lg-3">
						<select name="action" id="frm_action" className="form-select">
							<option value="">Choose an action...</option>
							<option value="Delete">Delete</option>
							<option value="Enable">Enable</option>
							<option value="Disable">Disable</option>
						</select>
					</div>
					<div className="col-lg-9">
						<button 
						type="button" 
						onClick={()=>applyToSelected(document.getElementById('frm_action').value)} 
						className="btn btn-block btn-primary">Apply to selected</button>
					</div>
				</div>  
                }
				{records && records.length===0 &&						
					<div className='text-center'>No record Found!</div>						
  				} 			
				</div>
				</form>
				
				{pageCount>1 && 
				    <div className="card-body table-responsive">
					<Pagination data={{
					'total'			:total,
					'item_per_page'	:item_per_page,
					'page_number'	:page_number,
					'handlePaginate':handlePaginate						
					}}/>
					</div>
				}				
                
			</div>    
			</div>
		</div>		
		</section>
		
	</>
    );  
}

export default Block;